(() => {
  if (customElements.get('armor-cookie-preferences')) return;

  const bannerUrl = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
  const nativeBannerUrl = `${window.location.origin}/cdn/shopifycloud/privacy-banner/storefront-banner.js`;
  let loading;
  let opening = false;
  const bannerAvailable = () => typeof window.privacyBanner?.showPreferences === 'function';

  function loadBanner() {
    if (bannerAvailable()) return Promise.resolve(window.privacyBanner);
    if (loading) return loading;

    loading = new Promise((resolve, reject) => {
      let script = Array.from(document.scripts).find((item) =>
        [bannerUrl, nativeBannerUrl].includes(item.src.split(/[?#]/)[0])
      );
      const owned = !script;
      if (owned) {
        script = document.createElement('script');
        script.src = bannerUrl;
        script.async = true;
      }

      let settled = false;
      const finish = (error) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        script.removeEventListener('load', loaded);
        script.removeEventListener('error', failed);
        if (error) {
          if (owned) script.remove();
          reject(error);
        } else {
          resolve(window.privacyBanner);
        }
      };
      const loaded = () => finish(bannerAvailable() ? null : new Error('Cookie preferences API unavailable'));
      const failed = () => finish(new Error('Cookie preferences could not load'));
      const timer = setTimeout(failed, 10000);
      script.addEventListener('load', loaded);
      script.addEventListener('error', failed);
      if (owned) document.head.append(script);
    }).catch((error) => {
      loading = null;
      throw error;
    });

    return loading;
  }

  class ArmorCookiePreferences extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      if (!this.button || !this.status) return;
      this.handleClick ||= this.openPreferences.bind(this);
      this.button.addEventListener('click', this.handleClick);
      this.button.hidden = false;
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    async openPreferences() {
      if (opening) return;
      opening = true;
      this.button.setAttribute('aria-disabled', 'true');
      this.button.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      try {
        const banner = await loadBanner();
        if (!this.isConnected) return;
        // Native Shopify resolves its own configuration; no headless credentials or consent writes.
        await banner.showPreferences();
      } catch {
        this.status.textContent = "Cookie preferences couldn't load. Please try again.";
      } finally {
        opening = false;
        this.button.removeAttribute('aria-disabled');
        this.button.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('armor-cookie-preferences', ArmorCookiePreferences);
})();
